'use client';

import { ThemeProvider as NextThemesProvider, useTheme } from 'next-themes';
import { Toaster } from 'sonner';
import type { ReactNode } from 'react';

// Light, dark or follow the system; the choice lives in the account menu (Appearance).
// Light by default until every page is redesigned: older screens still hard-code light colours,
// so a dark system setting must not switch them on unasked. #304 returns this to "system".
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      {children}
    </NextThemesProvider>
  );
}

// Toasts follow the same theme as the page.
export function ThemedToaster() {
  const { resolvedTheme } = useTheme();
  return <Toaster theme={resolvedTheme === 'dark' ? 'dark' : 'light'} />;
}
